import { getDesiredAssignmentsSchema } from '../../intune-utlity';
import { AndroidCompliancePolicySchema } from './model';

export const updateSchema = (formValue: any, schema: AndroidCompliancePolicySchema): any => {
    // update your schema here
    schema.contains.properties.policy.properties.displayName.const = formValue.displayName;
    schema.contains.properties.policy.properties.description.const = formValue.description;

    const combinationOfCertifiedDeviceAndBasicIntegrity = formValue.combinationOfCertifiedDeviceAndBasicIntegrity;

    if (combinationOfCertifiedDeviceAndBasicIntegrity === 'notSet') {
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationBasicIntegrity = {
            type: 'null',
        };
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationCertifiedDevice = {
            type: 'null',
        };
    } else if (combinationOfCertifiedDeviceAndBasicIntegrity === 'optionOne') {
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationBasicIntegrity = {
            type: 'boolean',
            const: true,
        };
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationCertifiedDevice = {
            type: 'null',
        };
    } else if (combinationOfCertifiedDeviceAndBasicIntegrity === 'optionTwo') {
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationBasicIntegrity = {
            type: 'boolean',
            const: true,
        };
        schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationCertifiedDevice = {
            type: 'boolean',
            const: true,
        };
    }

    // device health
    if (formValue.deviceThreatProtectionRequiredSecurityLevel) {
        schema.contains.properties.policy.properties.deviceThreatProtectionRequiredSecurityLevel.const =
            formValue.deviceThreatProtectionRequiredSecurityLevel;
        schema.contains.properties.policy.properties.deviceThreatProtectionRequiredSecurityLevel.type = 'string';
    } else {
        schema.contains.properties.policy.properties.deviceThreatProtectionRequiredSecurityLevel = { type: 'null' };
    }
    // schema.contains.properties.policy.properties.playIntegrityVerdict = {
    //     type: 'boolean',
    //     const: formValue.securityRequireSafetyNetAttestationBasicIntegrity,
    // };

    schema.contains.properties.policy.properties.advancedThreatProtectionRequiredSecurityLevel.const =
        formValue.advancedThreatProtectionRequiredSecurityLevel;

    // device properties
    if (formValue.osMinimumVersion) {
        schema.contains.properties.policy.properties.osMinimumVersion.const = formValue.osMinimumVersion;
        schema.contains.properties.policy.properties.osMinimumVersion.type = 'string';
    } else {
        schema.contains.properties.policy.properties.osMinimumVersion = { type: 'null' };
    }

    if (formValue.osMaximumVersion) {
        schema.contains.properties.policy.properties.osMaximumVersion.const = formValue.osMaximumVersion;
        schema.contains.properties.policy.properties.osMaximumVersion.type = 'string';
    } else {
        schema.contains.properties.policy.properties.osMaximumVersion = { type: 'null' };
    }

    if (formValue.minAndroidSecurityPatchLevel) {
        schema.contains.properties.policy.properties.minAndroidSecurityPatchLevel.const =
            formValue.minAndroidSecurityPatchLevel;
        schema.contains.properties.policy.properties.minAndroidSecurityPatchLevel.type = 'string';
    } else {
        schema.contains.properties.policy.properties.minAndroidSecurityPatchLevel = { type: 'null' };
    }

    schema.contains.properties.policy.properties.passwordRequired.const = formValue.passwordRequired;
    // boolean // check
    if (formValue.passwordRequired) {
        schema.contains.properties.policy.properties.passwordRequiredType = {
            type: 'string',
            const: formValue.passwordRequiredType,
        }; // string
        schema.contains.properties.policy.properties.passwordMinimumLength = {
            type: 'number',
            const: formValue.passwordMinimumLength,
        }; // number

        schema.contains.properties.policy.properties.passwordMinutesOfInactivityBeforeLock = {
            type: 'number',
            const: formValue.passwordMinutesOfInactivityBeforeLock,
        }; // number
        schema.contains.properties.policy.properties.passwordExpirationDays = {
            type: 'number',
            const: formValue.passwordExpirationDays,
        };

        schema.contains.properties.policy.properties.passwordPreviousPasswordCountToBlock = {
            type: 'number',
            const: formValue.passwordPreviousPasswordCountToBlock,
        }; // number

        schema.contains.properties.policy.properties.storageRequireEncryption = {
            type: 'boolean',
            const: formValue.storageRequireEncryption,
        }; //boolean

        schema.contains.properties.policy.properties.securityRequireIntuneAppIntegrity = {
            type: 'boolean',
            const: formValue.securityRequireIntuneAppIntegrity,
        }; //boolean

        schema.contains.properties.policy.properties.passwordRequiredType = {
            type: 'string',
            const: formValue.passwordRequiredType,
        };
    } else {
        delete schema.contains.properties.policy.properties.passwordMinimumLength;
        delete schema.contains.properties.policy.properties.passwordRequiredType;
        delete schema.contains.properties.policy.properties.passwordMinutesOfInactivityBeforeLock;

        delete schema.contains.properties.policy.properties.passwordExpirationDays;
        delete schema.contains.properties.policy.properties.passwordPreviousPasswordCountToBlock;
    }

    schema.contains.properties.assignments = getDesiredAssignmentsSchema(formValue);
    return schema;
};
